import { Observable } from 'rxjs';
import { PneuConfiguratorToken } from '../../model/content-tiles.model';

export abstract class TokenGenerationAdapter {
  abstract generateToken(
    tokenName: string, saveToken: boolean
  ): Observable<PneuConfiguratorToken>;
}
